"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PolicyDefinitionList = exports.createPolicyDefinitionList = void 0;
var tslib_1 = require("tslib");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var definition_list_1 = require("../definition-list");
var FORMAT_DATE_OPTIONS = { style: string_formatters_1.DateFormatStyle.STANDARD, timezone: (0, string_formatters_1.getLocalTimezone)() };
function createPolicyDefinitionList(policy) {
    var carrierName = policy.carrierName, displayName = policy.displayName, clientHref = policy.clientHref, clientName = policy.clientName, endDate = policy.endDate, linesOfCoverage = policy.linesOfCoverage, startDate = policy.startDate, policyNumber = policy.policyNumber, totalCost = policy.totalCost, _a = policy.formatDateOptions, formatDateOptions = _a === void 0 ? FORMAT_DATE_OPTIONS : _a;
    var formattedStartDate = startDate;
    if (typeof startDate === 'string') {
        formattedStartDate = new Date(startDate);
    }
    var formattedEndDate = endDate;
    if (typeof endDate === 'string') {
        formattedEndDate = new Date(endDate);
    }
    var effectiveDates = startDate && endDate
        ? "".concat((0, string_formatters_1.formatDate)(formattedStartDate, formatDateOptions), " - ").concat((0, string_formatters_1.formatDate)(formattedEndDate, formatDateOptions))
        : '-';
    var optionalItems = [];
    if (clientName) {
        optionalItems.push({
            type: 'name',
            title: 'Client',
            value: clientName,
            href: clientHref,
        });
    }
    if (displayName) {
        optionalItems.push({
            type: 'name',
            title: 'Display name',
            value: displayName,
        });
    }
    if (totalCost) {
        optionalItems.push({
            type: 'currency',
            title: 'Total cost',
            value: totalCost,
        });
    }
    if (policyNumber) {
        optionalItems.push({
            type: 'number',
            title: 'Policy number',
            value: policyNumber,
            target: '_blank',
        });
    }
    var items = optionalItems.concat([
        {
            type: 'document',
            title: 'Line of coverage',
            value: linesOfCoverage.join(', '),
        },
        {
            type: 'dateRange',
            title: 'Effective dates',
            value: effectiveDates,
        },
        {
            type: 'business',
            title: 'Carrier',
            value: carrierName,
        },
    ]);
    return items;
}
exports.createPolicyDefinitionList = createPolicyDefinitionList;
function PolicyDefinitionList(props) {
    var policyDefinition = props.policyDefinition, hideTitle = props.hideTitle;
    return (react_1.default.createElement(definition_list_1.DefinitionList, { hideTitle: hideTitle, items: createPolicyDefinitionList(policyDefinition), labelWidth: "150px" }));
}
exports.PolicyDefinitionList = PolicyDefinitionList;
//# sourceMappingURL=index.js.map